import styled from 'styled-components'
import MenuButtonUi from '../../ui/MenuButtonUi'

const ColorMenuButtonUi = styled(MenuButtonUi)`
  padding: 0 5px;
`

export default ColorMenuButtonUi
